import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Reveal, MaskedLines, Eyebrow } from "./Reveal";

export const PageHero = ({ eyebrow, titleLines, intro, image, imageAlt, children }) => (
  <section className="relative overflow-hidden bg-brand-mist pt-32 pb-16 lg:pt-44 lg:pb-24">
    <div className="pointer-events-none absolute -right-32 -top-32 h-96 w-96 rounded-full border-[40px] border-teal-100/60" aria-hidden="true" />
    <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
      <div className={`grid items-center gap-12 ${image ? "lg:grid-cols-2" : ""}`}>
        <div>
          <Reveal><Eyebrow>{eyebrow}</Eyebrow></Reveal>
          <MaskedLines
            onLoad
            lines={titleLines}
            className="font-display text-4xl font-black leading-[1.05] text-brand-ink sm:text-5xl lg:text-6xl"
          />
          {intro && (
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              className="mt-6 max-w-xl text-base leading-relaxed text-slate-600 md:text-lg"
            >
              {intro}
            </motion.p>
          )}
          {children}
        </div>
        {image && (
          <Reveal delay={0.25}>
            <div className="overflow-hidden rounded-[2rem] border border-slate-200 shadow-xl shadow-slate-900/5">
              <img src={image} alt={imageAlt} className="aspect-[4/3] w-full object-cover" loading="eager" />
            </div>
          </Reveal>
        )}
      </div>
    </div>
  </section>
);

export const CtaLink = ({ to, children, testId, dark = false, onClick }) => {
  const cls = `inline-flex items-center justify-center rounded-full px-8 py-4 font-display text-base font-bold shadow-lg transition-[background-color,transform] duration-200 hover:-translate-y-0.5 ${
    dark ? "bg-brand-ink text-white shadow-slate-900/20 hover:bg-slate-800" : "bg-brand-teal text-white shadow-teal-900/15 hover:bg-teal-600"
  }`;
  if (to.startsWith("#")) {
    return (
      <a href={to} data-testid={testId} onClick={onClick} className={cls}>
        {children}
      </a>
    );
  }
  return (
    <Link to={to} data-testid={testId} onClick={onClick} className={cls}>
      {children}
    </Link>
  );
};
